import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { useMetaPixel } from './hooks/useMetaPixel';
// Main App component - renders the landing page
export function App() {
  // Initialize Meta Pixel - PageView fires once on initial load only
  useMetaPixel('1936019550624887');
  return <LandingPage data-id="element-0" />;
}